import { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import Autocomplete from "@mui/material/Autocomplete/Autocomplete";
import Checkbox from "@mui/material/Checkbox/Checkbox";
import TextField from "@mui/material/TextField/TextField";
import { ChipsSkill } from "../components/Chips";
import { IHardSkillsDto } from "../../../@types/curriculum.type";
import { getAllHardSkillReference } from "../../../services/api/Curriculum/HardSkills/hardSkillsService";

interface HardSkillProps {
  setValue: React.Dispatch<React.SetStateAction<IHardSkillsDto[]>>;
  hardSkills: IHardSkillsDto[];
  isEdit: boolean;
}

export const HardSkill: React.FC<HardSkillProps> = ({
  setValue,
  hardSkills,
  isEdit,
}) => {
  const [optionsSkills, setOptionsSkills] = useState<IHardSkillsDto[]>([]);

  useEffect(() => {
    loadInfo();
  }, []);

  const loadInfo = async () => {
    const response = (await getAllHardSkillReference()) as IHardSkillsDto[];
    setOptionsSkills(response);
    setValue(hardSkills);
  };

  return (
    <>
      <div className={styles.hardSkill}>
        <div className={styles.divSkills}>
          {isEdit && (
            <Autocomplete
              options={optionsSkills}
              isOptionEqualToValue={(option, value) =>
                option.description == value.description
              }
              getOptionLabel={(option) => option.description || ""}
              value={hardSkills || []}
              onChange={(_, newValue) => {
                setValue(newValue);
              }}
              multiple
              noOptionsText="Sem opções"
              disableCloseOnSelect
              renderOption={(props, option, { selected }) => {
                const { key, ...optionProps } = props;
                return (
                  <li key={option.id} {...optionProps}>
                    <Checkbox style={{ marginRight: 8 }} checked={selected} />
                    {option.description}
                  </li>
                );
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Selecione suas Competências"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  fullWidth
                />
              )}
            />
          )}
          <div className={styles.skills}>
            {hardSkills && hardSkills.length > 0 && (
              <ChipsSkill
                skills={hardSkills}
                type="hardskill"
                editable={true}
                setValue={setValue}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};
